var map = {
	"./": 72812,
	"./App": 54111,
	"./App.css": 44050,
	"./App.js": 54111,
	"./App.test": 26029,
	"./App.test.js": 26029,
	"./Cart": 21712,
	"./Cart.jsx": 21712,
	"./components/AboutUs": 53404,
	"./components/AboutUs.jsx": 53404,
	"./components/Account/Address": 14538,
	"./components/Account/Address.jsx": 14538,
	"./components/Account/MyOrders": 50162,
	"./components/Account/MyOrders.jsx": 50162,
	"./components/Account/ProfileInfo": 3872,
	"./components/Account/ProfileInfo.jsx": 3872,
	"./components/Account/Wishlist": 16898,
	"./components/Account/Wishlist.jsx": 16898,
	"./components/Checkout": 63407,
	"./components/Checkout.jsx": 63407,
	"./components/Collection": 42059,
	"./components/Collection.jsx": 42059,
	"./components/Contact": 5667,
	"./components/Contact.jsx": 5667,
	"./components/CreateAccount": 95170,
	"./components/CreateAccount.jsx": 95170,
	"./components/FeaturedCat": 97805,
	"./components/FeaturedCat.jsx": 97805,
	"./components/Features": 24606,
	"./components/Features.jsx": 24606,
	"./components/FilterSidebar": 3809,
	"./components/FilterSidebar.jsx": 3809,
	"./components/FollowUs": 55192,
	"./components/FollowUs.jsx": 55192,
	"./components/Footer": 66990,
	"./components/Footer.jsx": 66990,
	"./components/Header": 37660,
	"./components/Header.jsx": 37660,
	"./components/Home": 22102,
	"./components/Home.jsx": 22102,
	"./components/LoadingSpinner": 16320,
	"./components/LoadingSpinner.jsx": 16320,
	"./components/MomsFavourite": 99430,
	"./components/MomsFavourite.jsx": 99430,
	"./components/Motherhood": 96700,
	"./components/Motherhood.jsx": 96700,
	"./components/NewArrivals": 80999,
	"./components/NewArrivals.jsx": 80999,
	"./components/OurServices": 87613,
	"./components/OurServices.jsx": 87613,
	"./components/PrivacyPolicy": 51205,
	"./components/PrivacyPolicy.jsx": 51205,
	"./components/ProductPage": 62747,
	"./components/ProductPage.jsx": 62747,
	"./components/ResponsiveHeader": 37086,
	"./components/ResponsiveHeader.jsx": 37086,
	"./components/ReturnPolicy": 14239,
	"./components/ReturnPolicy.jsx": 14239,
	"./components/ShippingPolicy": 29635,
	"./components/ShippingPolicy.jsx": 29635,
	"./components/Shop": 15735,
	"./components/Shop.jsx": 15735,
	"./components/SignUp": 67795,
	"./components/SignUp.jsx": 67795,
	"./components/SingleBlog": 11603,
	"./components/SingleBlog.jsx": 11603,
	"./components/Testimonial": 57770,
	"./components/Testimonial.jsx": 57770,
	"./components/TryACall": 46363,
	"./components/TryACall.jsx": 46363,
	"./components/VideoCrousel": 68613,
	"./components/VideoCrousel.jsx": 68613,
	"./components/ui/CouponBlock": 21793,
	"./components/ui/CouponBlock.jsx": 21793,
	"./components/ui/HeaderTop": 32760,
	"./components/ui/HeaderTop.jsx": 32760,
	"./components/ui/OffersCarousel": 24753,
	"./components/ui/OffersCarousel.jsx": 24753,
	"./components/ui/OrderProductsGallary": 89380,
	"./components/ui/OrderProductsGallary.jsx": 89380,
	"./components/ui/ProductImagesCarousel": 91637,
	"./components/ui/ProductImagesCarousel.jsx": 91637,
	"./components/ui/ReadMoreButton": 25769,
	"./components/ui/ReadMoreButton.jsx": 25769,
	"./components/ui/ScrollManager": 63200,
	"./components/ui/ScrollManager.jsx": 63200,
	"./components/ui/ScrollToTop": 37185,
	"./components/ui/ScrollToTop.jsx": 37185,
	"./components/ui/SimpleAccordion": 40532,
	"./components/ui/SimpleAccordion.jsx": 40532,
	"./context/LogContext": 42207,
	"./context/LogContext.js": 42207,
	"./context/LogState": 91933,
	"./context/LogState.js": 91933,
	"./css/OffersCarousel.css": 27888,
	"./css/OrderProductGallery.css": 12461,
	"./css/ProductImagesCarousel.css": 37250,
	"./css/ProductPage.css": 88051,
	"./css/SimpleAccordion.css": 63615,
	"./hooks/useAuth": 30342,
	"./hooks/useAuth.js": 30342,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./logo.svg": 69445,
	"./media/102661.png": 24843,
	"./media/Green Pulse Dot.webm": 24419,
	"./media/babydiaper.png": 70364,
	"./media/banner.jpg": 31257,
	"./media/c1.webp": 65405,
	"./media/c2.webp": 71152,
	"./media/c3.webp": 93363,
	"./media/c4.webp": 68974,
	"./media/c5.webp": 38697,
	"./media/c6.webp": 27980,
	"./media/discount.png": 8954,
	"./media/drysheet.jpg": 20607,
	"./media/drysheet.png": 41999,
	"./media/h1.webp": 70070,
	"./media/kidoriseLogo.png": 66058,
	"./media/mosquitonet.jpg": 69469,
	"./media/mu1.png": 96476,
	"./media/mu2.webp": 14383,
	"./media/mu3.webp": 62796,
	"./media/os1.jpg": 79492,
	"./media/os2.jpg": 31123,
	"./media/os3.jpg": 67958,
	"./media/os4.jpeg": 69730,
	"./media/p1.webp": 53774,
	"./media/p2.webp": 13071,
	"./media/p3.webp": 72204,
	"./media/p4.webp": 84381,
	"./media/pillow.jpg": 8420,
	"./media/pillow.png": 75456,
	"./media/profileLogo.svg": 22431,
	"./media/sailboat.webp": 87438,
	"./media/sleepingbag.png": 98952,
	"./media/sleepingbag1.jpg": 85115,
	"./media/sm1.jpg": 98234,
	"./media/sm2.png": 96373,
	"./media/sm3.jpg": 58472,
	"./media/sm4.jpg": 64795,
	"./media/testimonial1.jpg": 27077,
	"./media/testimonial2.jpg": 53498,
	"./media/testimonial3.jpg": 21783,
	"./media/testimonial4.jpg": 61548,
	"./media/tripleDot.svg": 51828,
	"./media/user.png": 33978,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./setupTests": 89472,
	"./setupTests.js": 89472,
	"./smoothScroll": 69157,
	"./smoothScroll.js": 69157,
	"./utils/accountScroll": 14736,
	"./utils/accountScroll.js": 14736,
	"./utils/convertToLocalTime": 22660,
	"./utils/convertToLocalTime.js": 22660,
	"./utils/deSlugify": 13308,
	"./utils/deSlugify.js": 13308,
	"./utils/formatDate": 18707,
	"./utils/formatDate.js": 18707,
	"./utils/getTruncatedTitles": 56969,
	"./utils/getTruncatedTitles.js": 56969,
	"./utils/slugify": 76701,
	"./utils/slugify.js": 76701,
	"./utils/usePreventTopScroll": 51789,
	"./utils/usePreventTopScroll.js": 51789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;